import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const headerBg = useColorModeValue('gray.50', 'whiteAlpha.50');
  const hoverBg = useColorModeValue('gray.50', 'whiteAlpha.50');
  const textColor = useColorModeValue('gray.700', 'white');
  const backgroundCardColor = useColorModeValue('white', 'navy.800');
  const inputColor = useColorModeValue('gray.800', 'whiteAlpha.900');
  const placeholderColor = useColorModeValue('gray.500', 'gray.400');
  const secondaryTextColor = useColorModeValue('gray.500', 'gray.400');
  const accentColor = useColorModeValue('teal.500', 'teal.300');
  const mutedBg = useColorModeValue('gray.50', 'whiteAlpha.50');
  const successColor = useColorModeValue('green.500', 'green.300');
  const pendingColor = useColorModeValue('orange.500', 'orange.300');

  return {
    borderColor,
    headerBg,
    hoverBg,
    textColor,
    backgroundCardColor,
    inputColor,
    placeholderColor,
    secondaryTextColor,
    accentColor,
    mutedBg,
    successColor,
    pendingColor,
  };
};
